/* Bean Bros collection page: "Load more" adds the next page under the current products. */
(function () {
  if (window.__bbLoadMore) return;
  window.__bbLoadMore = true;

  // Editorial card: put it into the grid at its position (page 1, no filters active)
  function placeEditorial() {
    var tpl = document.querySelector('template[data-bb-editorial]');
    var g = grid(document);
    if (!tpl || !g || g.querySelector('.bb-ed-item')) return;
    if (/[?&](filter\.|page=|q=)/.test(location.search)) return;
    var items = g.querySelectorAll(':scope > .grid-product');
    var pos = parseInt(tpl.getAttribute('data-position'), 10) || 5;
    if (items.length < pos) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var cls = items[0].className.split(' ').filter(function (c) { return /up--|small--|one-|two-|three-|grid__item/.test(c); });
    node.className = cls.join(' ') + ' grid-product bb-ed-item';
    g.insertBefore(node, items[pos - 1]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeEditorial); else placeEditorial();
  document.addEventListener('collection:reloaded', placeEditorial);

  function grid(root) {
    return (root || document).querySelector('#CollectionAjaxContent .grid--uniform');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-next]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    fetch(btn.href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var from = grid(doc);
        var to = grid(document);
        if (!from || !to) { window.location = btn.href; return; }

        var firstNew = null;
        Array.prototype.slice.call(from.children).forEach(function (item) {
          // Impulse hides [data-aos] items until animated
          item.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-init', 'aos-animate'); });
          if (item.hasAttribute('data-aos')) item.classList.add('aos-init', 'aos-animate');
          var node = document.importNode(item, true);
          to.appendChild(node);
          if (!firstNew) firstNew = node;
        });

        var more = document.querySelector('[data-bb-more]');
        var newMore = doc.querySelector('[data-bb-more]');
        if (more && newMore) {
          more.replaceWith(document.importNode(newMore, true));
        } else if (more) {
          btn.remove();
        }
        // Keep keyboard users in place: focus the first new product link
        var link = firstNew && firstNew.querySelector('a');
        if (link) link.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('bb:products-loaded'));
      })
      .catch(function () { window.location = btn.href; });
  });
})();
